<template>
  <v-tooltip
    v-model="visible" 
    v-show="visible"                 
    top
    absolute 
    color="white"
    :position-x="pos.x"
    :position-y="pos.y"
  >
    <Cpage
      :key="pos.x+pos.y"
      :pageTemplate="event.tooltip"
      :customparams="event.params"
      :page="event.page"
      :modal="event.modal"
      :modalKey="event.modalKey"
      :form="false"
      hook="hook"
      :mod="false"
    />
  </v-tooltip>
</template>

<script>
import { tooltipBus } from './tooltipBus'
import Cpage from '../../engine/outils/constructPage/Page'
export default {
    name :'TooltipPl',

  data: () => ({
    visible: false,
    event: {},
    pos: { x: 0, y: 0 }
  }),

    components : {
        Cpage,
        },

  methods: {
    showTooltip({ tooltip, params, id, x, y, page, modal, modalKey }) {
      this.event = { tooltip, params, id, page, modal, modalKey }
      this.pos = { x, y }
      this.visible = true
    },
    hideTooltip() {
      this.visible = false
      this.event = {}
    },
  },

  created() {
    tooltipBus.$on('show-tooltip', this.showTooltip)
    tooltipBus.$on('hide-tooltip', this.hideTooltip)
  },

  beforeDestroy() {
    tooltipBus.$off('show-tooltip', this.showTooltip)
    tooltipBus.$off('hide-tooltip', this.hideTooltip)
  },
}
</script>
